/**
 * Sentry Error Tracking
 * Отдельный файл для подключения в head
 *
 * Именованные импорты вместо `import * as Sentry` + полного `window.Sentry = Sentry`:
 * namespace-глобал заставлял rollup сохранить весь SDK, включая неиспользуемый
 * Session Replay (~200+ КБ и полифилы, на которые ругался PageSpeed).
 */
import {
  init,
  captureException,
  browserTracingIntegration,
} from '@sentry/browser'
;(function () {
  const environment = window.sentryEnvironment || 'production'

  // Забираем очередь ранних ошибок, накопленную inline-шимом (functions.php),
  // и снимаем его обработчики — дальше глобальные ошибки ловит сам Sentry.
  window.removeEventListener('error', window.aflEarlyErrorHandler)
  window.removeEventListener('unhandledrejection', window.aflEarlyErrorHandler)
  const earlyErrors = window.aflEarlyErrors || []
  delete window.aflEarlyErrors
  delete window.aflEarlyErrorHandler

  // Не запускаем на dev
  if (environment === 'development') {
    return
  }

  init({
    dsn: 'https://dfaf98fbf6356841be30ea38f5a1e40e@o4510177024147456.ingest.us.sentry.io/4510240284540928',
    environment: environment,
    sendDefaultPii: true,
    release: 'appsflow@1',
    tracesSampleRate: 1.0,
    integrations: (integrations) => {
      const filtered = integrations.filter(
        (integration) => integration.name !== 'BrowserSession'
      )
      filtered.push(browserTracingIntegration())
      return filtered
    },
  })

  // Минимальный глобал для ручной отладки и стороннего кода;
  // полный namespace не выставляем — он ломает tree-shaking.
  window.Sentry = { captureException }

  // Доигрываем ошибки, случившиеся до инициализации.
  // reason — из unhandledrejection, error — из error-события,
  // message — фолбэк для cross-origin ошибок без объекта.
  // try/catch: трекинг опционален, сбой доигрывания не должен породить новую ошибку.
  try {
    for (const event of earlyErrors) {
      captureException(
        event.reason !== undefined ? event.reason : event.error || event.message
      )
    }
  } catch (e) {
    // намеренно глушим
  }
})()
